export interface ImageSize {
  title: string;
  width: number;
  height: number;
  span?: number;
  fill?: boolean;
}

export interface ImageGroup {
  name: string;
  title: string;
  intro: string;
  sizes: Array<ImageSize[]>;
}

const addIntros = (groups: Array<Omit<ImageGroup, "intro">>): Array<ImageGroup> => {
  return groups.map((group) => {
    return {
      ...group,
      intro: `Choose from ${group.sizes.length} standard sizes or download them all at once.`
    };
  });
};

const groups: ImageGroup[] = addIntros([
  {
    title: "Facebook",
    name: "facebook",
    sizes: [
      [
        {
          title: "Story",
          width: 1080,
          height: 1920
        },
        {
          title: "Vertical post",
          width: 1080,
          height: 1350
        },
        {
          title: "Shared image",
          width: 1200,
          height: 630
        }
      ],
      [
        {
          title: "Page cover",
          width: 820,
          height: 312
        },
        {
          title: "Event cover",
          width: 1920,
          height: 1080
        },
        {
          title: "Group cover",
          width: 1640,
          height: 859
        }
      ],
      [
        {
          title: "Profile image",
          width: 180,
          height: 180
        },
        {
          title: "Ad (Carousel)",
          width: 600,
          height: 600
        },
        {
          title: "Ad (Link)",
          width: 1200,
          height: 628
        },
        {
          title: "News feed",
          width: 1200,
          height: 628
        }
      ]
    ]
  },
  {
    title: "Instagram",
    name: "instagram",
    sizes: [
      [
        {
          title: "Story",
          width: 1080,
          height: 1920
        },
        {
          title: "Vertical post",
          width: 1080,
          height: 1350
        }
      ],
      [
        {
          title: "Square post",
          width: 1080,
          height: 1080
        },
        {
          title: "Horizontal post",
          width: 1080,
          height: 566
        }
      ],
      [
        {
          title: "Profile image",
          width: 110,
          height: 110
        },
        {
          title: "Thumbnail",
          width: 161,
          height: 161
        }
      ]
    ]
  },
  {
    title: "Twitter",
    name: "twitter",
    sizes: [
      [
        {
          title: "Share image",
          width: 1200,
          height: 675
        },
        {
          title: "Link with image",
          width: 800,
          height: 418
        }
      ],
      [
        {
          title: "Header",
          width: 1500,
          height: 500
        },
        {
          title: "Website card",
          width: 1024,
          height: 512
        }
      ],
      [
        {
          title: "Profile image",
          width: 400,
          height: 400
        },
        {
          title: "In-stream photo",
          width: 440,
          height: 220
        }
      ]
    ]
  },
  {
    title: "YouTube",
    name: "youtube",
    sizes: [
      [
        {
          title: "Channel icon",
          width: 800,
          height: 800
        }
      ],
      [
        {
          title: "Channel art",
          width: 2560,
          height: 1440
        },
        {
          title: "Banner",
          width: 2560,
          height: 1140
        }
      ],
      [
        {
          title: "Thumbnail",
          width: 1280,
          height: 720
        }
      ]
    ]
  },
  {
    title: "Pinterest",
    name: "pinterest",
    sizes: [
      [
        {
          title: "Pin",
          width: 800,
          height: 1200
        }
      ],
      [
        {
          title: "Board cover",
          width: 222,
          height: 150,
          fill: true
        },
        {
          title: "Big Thumbnail",
          width: 222,
          height: 150,
          fill: true
        }
      ],
      [
        {
          title: "Profile image",
          width: 165,
          height: 165
        },
        {
          title: "Small thumbnail",
          width: 55,
          height: 55
        }
      ]
    ]
  },
  {
    title: "LinkedIn",
    name: "linkedin",
    sizes: [
      [
        {
          title: "Square image",
          width: 1140,
          height: 736
        },
        {
          title: "LinkedIn image",
          width: 1200,
          height: 628
        },
        {
          title: "Company banner",
          width: 646,
          height: 220
        }
      ],
      [
        {
          title: "Personal background",
          width: 1584,
          height: 396
        },
        {
          title: "Company background",
          width: 1536,
          height: 768
        },
        {
          title: "Company hero",
          width: 1128,
          height: 376
        }
      ],
      [
        {
          title: "Profile image",
          width: 400,
          height: 400
        },
        {
          title: "Company logo",
          width: 300,
          height: 300
        },
        {
          title: "Square logo",
          width: 60,
          height: 60
        }
      ]
    ]
  },
  {
    title: "Google Display",
    name: "google_display",
    sizes: [
      [
        {
          title: "Skyscraper",
          width: 120,
          height: 600,
          fill: true
        }
      ],
      [
        {
          title: "Leaderboard",
          width: 728,
          height: 90
        },
        {
          title: "Banner",
          width: 468,
          height: 68
        },
        {
          title: "Medium rectangle",
          width: 300,
          height: 250,
          span: 1
        },
        {
          title: "Large rectangle",
          width: 336,
          height: 280,
          span: 1
        },
        {
          title: "Half page",
          width: 300,
          height: 600,
          span: 1
        },
        {
          title: "Half banner",
          width: 300,
          height: 400,
          span: 1
        }
      ],
      [
        {
          title: "Wide Skyscraper",
          width: 160,
          height: 600,
          span: 1,
          fill: true
        }
      ]
    ]
  },
  {
    title: "Email & blog",
    name: "email_and_blog",
    sizes: [
      [
        {
          title: "Blog image",
          width: 750,
          height: 750
        }
      ],
      [
        {
          title: "Email header",
          width: 600,
          height: 200
        },
        {
          title: "Blog header",
          width: 1200,
          height: 600
        }
      ]
    ]
  }
]);

export default groups;
